import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {DataService} from '../../../../Services/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmDialogService } from '../../../../Services/confirm-dialog.service';
import { TaxModel } from '../../../../DataModels/tax-model';
import { ItemCategoryModel } from '../../../../DataModels/item-category-model';
import {AccountModel} from '../../../../DataModels/account-model';
import { ResponseModel } from '../../../../DataModels/response-model';
import { BsToastService} from '../../../../Services/bs-toast-service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-item-category-form',
  templateUrl: './item-category-form.component.html',
  styleUrls: ['./item-category-form.component.css'],
  standalone: false
})
export class ItemCategoryFormComponent implements OnInit {
  itemCategoryID;
  itemCategory: ItemCategoryModel;
  itemCategoryForm: UntypedFormGroup;
  tax$: TaxModel[];
  itemCategory$: ItemCategoryModel[];
  accountList: AccountModel[];
  submitted = false;
  isSaveNew = false;
  originalSnapshot: any = {};

  buttonConfig: any = {
    save: true,
    close: true,
    reset: true,
    delete: true,
    saveNew: true,
    saveClose: true,
    print: false,
  };

  constructor(
    private table: DataService,
    private notification: BsToastService,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private confirmDialogService: ConfirmDialogService,
    private titleService: Title
  ) {
    this.createForm();
    this.itemCategoryID = this.route.snapshot.params.id;
  }

  get f() {
    return this.itemCategoryForm.controls;
  }

  createForm() {
    this.itemCategoryForm = this.formBuilder.group({
      id: new UntypedFormControl(''),
      name: new UntypedFormControl(''),
      expense_account_id: new UntypedFormControl(''),
      revenue_account_id: new UntypedFormControl(''),
      receivable_tax_1_id: new UntypedFormControl(''),
      receivable_tax_2_id: new UntypedFormControl(''),
      payable_tax_1_id: new UntypedFormControl(''),
      payable_tax_2_id: new UntypedFormControl(''),
      parent_name: new UntypedFormControl(''),
      active: new UntypedFormControl(true),
    });
  }

  ngOnInit() {
    this.titleService.setTitle($localize`:Item Category @@itemCategory:Item Category`);
    this.LoadAccount();
    // this.tax$ = this.table.getData('tax');
    // this.itemCategory$ = this.table.getData('item_category');
    this.table.getApiListData('tax', '?pageNumber=0&pageSize=999999').subscribe((res: any) => {
      this.tax$ = res.Data as TaxModel[];
    });
    this.table.getApiListData('item_category', '?pageNumber=0&pageSize=999999').subscribe((res: any) => {
      this.itemCategory$ = res.Data as ItemCategoryModel[];
    });
    if (this.itemCategoryID) {
      this.LoadData();
      this.buttonConfig.reset = false;
    } else {
      Promise.resolve().then(() => {
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      });
    }
  }

  private LoadData() {
    this.table.getData('item_category', this.itemCategoryID).subscribe(
      (result: any) => {
        const data = (result && result.Data !== undefined) ? result.Data : result;
        this.itemCategory = data as ItemCategoryModel;
        this.itemCategoryForm.patchValue(this.itemCategory);
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      }
    );
  }

  private LoadAccount() {
    this.table.getApiListData('account', '?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.accountList = result.Data;
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {}
    );
  }

  saveClose() {
    if (this.onSave(true)) {
    }
  }

  saveNew() {
    // Clear only for Save & New, after async POST/PATCH succeeds
    this.isSaveNew = true;
    this.onSave(false);
  }

  resetForm() {
    this.resetToDefaults();
    try {
      this.originalSnapshot = this.buildSnapshot();
    } catch {
    }
  }

  private resetToDefaults(): void {
    // Reset the form to known defaults and clear component state for a fresh entry
    this.itemCategoryForm.reset({
      id: null,
      name: '',
      expense_account_id: '',
      revenue_account_id: '',
      receivable_tax_1_id: '',
      receivable_tax_2_id: '',
      payable_tax_1_id: '',
      payable_tax_2_id: '',
      parent_name: '',
      active: true,
    });

    this.itemCategory = {
      id: null,
      name: '',
      expense_account_id: '',
      revenue_account_id: '',
      receivable_tax_1_id: '',
      receivable_tax_2_id: '',
      payable_tax_1_id: '',
      payable_tax_2_id: '',
      parent_name: '',
      active: true,
    } as unknown as ItemCategoryModel;
    this.itemCategoryID = null;
    this.submitted = false;
    try {
      this.originalSnapshot = this.buildSnapshot();
    } catch {
    }
  }

  onClose() {
    this.router.navigate(['admin/item-category-list']).then();
  }

  deleteItem() {
    let retMsg = '';
    const messages: string[] = [
      $localize`:Are you sure you want to delete item category? @@areYouSureYouWantToDeleteItemCategory:Are you sure you want to delete item category?`,
      this.itemCategory.name,
    ];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.table.deleteDataById('item_category', this.itemCategoryID).subscribe(
          (result) => {
            retMsg = result;
            // this.notification.success($localize`:Deleted @@deleted:Deleted`);
          },
          (error: HttpErrorResponse) => {
            // this.notification.error($localize`:Error @@error:Error`);
            console.log(error);
          },
          () => {
            this.onClose();
          }
        );
      },
      () => {
        this.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      }
    );
  }

  onSave(saveClose: boolean) {
    this.submitted = true;
    if (this.itemCategoryForm.invalid) {
      this.notification.showWarningToast($localize`:Form Errors! @@formErrors:Form Errors!`);
      return false;
    }
    this.itemCategory = Object.assign({}, this.itemCategoryForm.value);
    if (this.itemCategoryID) {
      if (this.itemCategoryForm.invalid === false) {
        this.table.patch('item_category', this.itemCategoryID, this.itemCategory).then(
          () => {
            try {
              this.originalSnapshot = this.buildSnapshot();
            } catch {
            }
            if (saveClose) {
              this.onClose();
            } else if (this.isSaveNew) {
              this.isSaveNew = false;
              this.resetToDefaults();
            }
          },
          (error: HttpErrorResponse) => {
            console.log(error);
          }
        );
      }
    } else {
      this.table.postWithPromise('item_category', this.itemCategory).then((res) => {
        let apiReturn: any = null;
        if (typeof res === 'object') {
          apiReturn = JSON.parse(JSON.stringify(res));
        }
        this.itemCategoryID = apiReturn?.id;
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
        if (saveClose) {
          this.onClose();
        } else if (this.isSaveNew) {
          this.isSaveNew = false;
          this.resetToDefaults();
        }
      }).catch((error: HttpErrorResponse) => {
        console.log(error);
      }).finally(() => {
        this.submitted = false;
      });
      return true;
    }
    this.submitted = false;
    return true;
  }

  buildSnapshot(): any {
    try {
      return this.itemCategoryForm.getRawValue();
    } catch {
      return {};
    }
  }

  hasChanges(): boolean {
    try {
      const current = this.buildSnapshot();
      const original = this.originalSnapshot || {};
      return JSON.stringify(current) !== JSON.stringify(original);
    } catch {
      return false;
    }
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }
}
